export const paths = [
  { name: 'home', pathname: '/' },
  { name: 'work', pathname: '/work/0' },
  { name: 'about', pathname: '/about' },
  { name: 'contact', pathname: '/contact' },
];